import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import createServices from './services/ioc/service-creator';
import { initializeIcons } from '@fluentui/react/lib/Icons';
import { BrowserRouter } from "react-router-dom";
import { ServicesProvider } from './services/ioc/service-dependency';

const services = createServices();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

initializeIcons("https://res.cdn.office.net/files/fabric-cdn-prod_20241209.001/assets/icons/");

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ServicesProvider services={services}>
        <App />
      </ServicesProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
